import { EntityOtherService } from 'app/entities/other/entity-other.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

import { EntityDetailsService } from 'app/entities/details/entity-details.service';
import { EntityIdDetails } from 'app/shared/models/entity-id-details.model';
import { environment } from 'environments/environment';
import { EntityOtherComponent } from 'app/entities/other/entity-other.component';

@Component({
  templateUrl: './entity-relations.component.html'
})

export class EntityRelationsComponent extends EntityOtherComponent implements OnInit {
  @Input() entityIdDetails: EntityIdDetails;

  showGWTFrame = !environment.isDevelopmentEnv;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public entityDetailsService: EntityDetailsService,
    public domSanitizer: DomSanitizer,
    public entityOtherService: EntityOtherService) {
    super(route, router, domSanitizer, entityDetailsService, entityOtherService);
  }

  ngOnInit() {
    this.entityIdDetails = this.entityDetailsService.getEntityIdDetails();

    this.entityDetailsService.entityDetailsUpdated.subscribe(
      (entityDetails) => {
        this.entityIdDetails = entityDetails;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/relations/entity-relations.component.ts